// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ec71d86","455":"468d0b30","977":"13cf4043"}[chunkId] + ".chunk.js";
};